import React, { useState } from "react";
import "./CSS/PrivacyPolicy.css";
import { FaEnvelope, FaPhoneAlt } from "react-icons/fa";
import { Link } from "react-router-dom";

import { FaInstagram, FaTwitter, FaLinkedin } from 'react-icons/fa';


const Canclellation = ({ onContactClick }) => {
      const [menuOpen, setMenuOpen] = useState(false);
    
      const toggleMenu = () => {
        setMenuOpen(!menuOpen);
      };
  return (
   <div className="privacy-container">
            <header className="home-header">
           <div className="logo">
             <img
               alt="Designvio.pvt.Ltd"
               className="logo-icon"
               src="../Images/DLogo.png"
             />
           </div>
   
           <div className="hamburger" onClick={toggleMenu}>
             <div className="bar"></div>
             <div className="bar"></div>
             <div className="bar"></div>
           </div>
   
           <nav className={`nav-links ${menuOpen ? "open" : ""}`}>
             <a href="#about">ABOUT</a>
             <a href="#services">SERVICES</a>
             <a href="#work">WORK</a>
             <a href="#contact" onClick={onContactClick}>
               CONTACT
             </a>
           </nav>
         </header>
         <div className="privacy-header">
           <h1>Cancellation and Refund Policy</h1>
          <p className="breadcrumb">
              <Link to="/" className="breadcrumb-link">Home</Link> / 
              <span className="active"> Canclellation and Refund Policy</span>
            </p>
         </div>
   
         <div className="privacy-content">
           <h1>
           We currently ship products across India.</h1>
   
           <h2>Order Cancellation:</h2>
           <ul>
             <li>Orders can be canceled within 24 hours of placement, provided they haven’t been shipped.</li>
             <li>To cancel, email us at designvioux@gmailcom .</li>
           </ul>
   
           <h2>Refunds:</h2>
           <ul>
             <li>If your product is damaged, defective, or not as described, we offer a 100% refund or replacement.</li>
             <li>Refunds are processed within 7–10 working days to the original payment method.

</li>
           </ul>
           <h2>Return Conditions:</h2>
             <ul>
         <li>Items must be returned unused, in original packaging, with all tags and invoices.</li>
<li>Return requests must be raised within 3 days of delivery.</li>
</ul>
             </div>
            <footer className="footer" id='contact'>
                 <div className="footer-top">
                   <div className="footer-left">
                     <img src="../Images/DLogo.png" alt="Designvio Logo" className="footer-logo" />
                     {/* <h2>DESIGNVIO<br />(OPC) PVT LTD</h2> */}
            <div className="footer-address">
               <h3>Address</h3>
               <p>Branch 1: Designvio 523/B Karanje Peth, Satara.</p>
               <p>Branch 2: Designvio AssemblyRd, New Shahupuri, Kolhapur.</p>
             </div>
                   <nav className="footer-page">
                              {/* <a className='link-c' href="#about">ABOUT-US</a> */}
                            <Link className='link-c' to="/privacy-policy">Privacy Policy</Link>
                            <Link className='link-c' to="/terms-conditons">Terms And Conditions</Link>
                            <Link className='link-c' to="/cancellation">Cancellation And Refunf Policy</Link>
                            <Link className='link-c' to="/shipping">Shipping And Delivery Policy</Link>
                              {/* <a className='link-c'  href="#team">TEAM</a> */}
                              {/* <a className='link-c' href="#services">SERVICES</a>
                              <a className='link-c' href="#work">PORTFOLIO</a>
                              <a className='link-c' href="#faqs">FAQ-S</a>
                              <a className='link-c' href="#process">THE PROCESS</a> */}
                            </nav>
                   </div>
           
                   <div className="footer-right">
                     <div className="footer-box">
                       <h3 className='touch'>GET IN TOUCH</h3>
                       <p className='tel-link'>Tel: <a className='tel-link' href="tel:‪+917058035999‬">‪+91 7058035999‬</a> / <a className='tel-link' href="tel:‪+917875010115‬">‪+91 7875010115‬</a></p>
                       <hr />
                       <h3 className='follow'>FOLLOW US</h3>
                       <div className="social-icons">
                         <a className='social-link' href="https://instagram.com" target="_blank" rel="noreferrer"><FaInstagram /></a>
                         <a className='social-link' href="https://twitter.com" target="_blank" rel="noreferrer"><FaTwitter /></a>
                         <a className='social-link' href="https://linkedin.com" target="_blank" rel="noreferrer"><FaLinkedin /></a>
                       </div>
                     </div>
                   </div>
           
                 </div>
           
                 
                 <div className="footer-bottom">
                   <p>© 2024 Copyright <strong className='cp'>Designvio</strong></p>
                  
                 </div>
          
               </footer>
        
       </div>
     );
};

export default Canclellation;
